module.exports = __webpack_public_path__ + "static/media/home.0b08ef0d.svg";